import {
  USERS_LOGIN_REQUEST,
  USERS_LOGIN_SUCCESS,
  USERS_LOGIN_ERROR
} from "./loginTypes";

const initialState = {
  loading: false,
  isAuthenticated: false,
  token: "",
  errorMessage: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USERS_LOGIN_REQUEST:
      return {
        ...state,
        loading: true
      };
    case USERS_LOGIN_SUCCESS:
      // do something
      return {
        ...state,
        loading: false,
        token: action.payload,
        isAuthenticated: true,
        errorMessage: ""
      };
    case USERS_LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload
      };
    default:
      return state;
  }
};
